export default {
  async setPageContent({ commit, state }, { pageId, type }) {
    await this.$apiContent
      .getContentPage(pageId)
      .then((data) => {
        const routetemplate = this.$i18n.locale + '-' + pageId
        commit('setPageContent', { data, routetemplate, type })
        if (type === 'pages') commit('setContentPage', data, { root: true })
        commit('SET_LOADED', { type, value: true }, { root: true })
      })
      .catch((e) => {
        commit('setError', { statusCode: 500, message: 'Los servicios no responden' }, { root: true })
      })
  },
  async setEngineContent({ commit, dispatch, state }, { pageId, type, view, userData }) {
    await this.$apiContent
      .getContentPage(pageId)
      .then((data) => {
        const lang = this.$i18n.locale
        data = data.regions.MainRegion[0].content
        commit('setEngineContent', { data, view })
        commit('SET_LOADED', { type, value: true }, { root: true })
        const pageId = data.program
          .find((element) => element.program === userData.programs[0])
          .pagesByCategory.find((element) => element.category === userData.category).pageId
        commit('SET_PAGEID', { lang, pageId, type: 'pages' }, { root: true })
        commit('setContentPageId', { pageId, view })
        dispatch('setPageContent', { pageId, type: 'pages' })
      })
      .catch((e) => {
        commit('setError', { statusCode: 500, message: 'Los servicios no responden' }, { root: true })
      })
  }
}
